module.exports = __webpack_public_path__ + "static/media/GoodsReceiptNoteTemplate1.5fab1273.png";